import { createContext, useContext, useEffect, useState } from "react";
import { axiosInstance } from "../axiosInstance";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const token = localStorage.getItem("token");

  // all catalogue product api
  async function FetchAllProducts() {
    try {
      const response = await axiosInstance.get("/agent/catalogue/");
      if (response.data.status === "Success" || response.status === 200) {
        //  update count in header
        const count = response.data.data?.cart?.total_items || 0;
        setCartCount(count);
      }
    } catch (error) {
      console.log("Failed to fetch all products");
    }
  }

  useEffect(() => {
    if (token) {
      FetchAllProducts();
    }
  }, []);

  return (
    <CartContext.Provider value={{ cartCount, setCartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
